import React from 'react';

const MinimalLayout = props => {
  const { children } = props;

  return <div>{children}</div>;
};

export default MinimalLayout;
